import * as yup from "yup";
import { validarMoedaReal } from "../../core/utils/validarMoedaReal";

export const adicionalPizzaSchema = yup.object().shape({
    descricao: yup.string().required('O nome é obrigatório'),
    preco: yup.string().test('preco', 'Valor inválido', (valor) => {
        return !validarMoedaReal(valor, 0.00, undefined, true);
    }),
    detalhes: yup.string().optional(),
});
